import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';

/** 저장 HTML(레거시 문서 포함)이 표 제목·머리칸을 th 로 씀 */
export const SerpApStockTransferRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    [theme.breakpoints.down('md')]: {
      minWidth: 0,
    },
  },
  // 이관 대상 목록(8칸)만 가로 스크롤
  '& table + table': {
    marginTop: 16,
    minWidth: 640,
  },
  '& table th, & table td': {
    textAlign: 'center',
  },
}));
